import PropTypes from 'prop-types';
import DatasourceBaseOauthNew from "../Datasources/DatasourceBaseOauthNew.jsx";

const DatasourceHubspot = (props) => {

    const CrmServerTokenController = "/api/hubspot/tokens"
    const ClientId = "aad7ebcd-35d0-49a0-9bf6-81d9cc53bf11"
    const Scope = "oauth%20crm.objects.owners.read%20crm.objects.orders.read%20crm.objects.leads.read%20crm.objects.contacts.write%20crm.objects.companies.write%20crm.objects.companies.read%20crm.lists.read%20crm.objects.deals.read%20crm.objects.contacts.read"
    const RedirectUrl = "https://auth.cloudcti.nl/webapi/oauth2"
    const AuthUrl = "https://app.hubspot.com/oauth/authorize?scope=" + Scope + "&client_id=" + ClientId + "&response_type=code&redirect_uri=" + RedirectUrl

    props.IntegrationSettings.DatasourceSettings.DatasourceVersion = "3"

    return <DatasourceBaseOauthNew SecurityToken={props.SecurityToken} DatasourceData={props.DatasourceData} IntegrationSettings={props.IntegrationSettings} AuthUrl={AuthUrl} CrmServerTokenController={CrmServerTokenController} OnSetReady={props.OnSetReady}/>
}

DatasourceHubspot.propTypes = {
    SecurityToken: PropTypes.string,
    DatasourceData: PropTypes.object,
    IntegrationSettings: PropTypes.object,
    OnSetReady: PropTypes.func
}   

export default DatasourceHubspot